import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"max-width":"340px","margin":"20px auto"} }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { style: {"margin-left":"-30px","margin-top":"25px"} }
const _hoisted_6 = { class: "pl-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "field text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    closable: false,
    title: _ctx.t('content.register.content.title')
  }, {
    beforeHeader: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.getLogoByLocale,
        alt: "RiUM",
        style: {"width":"230px"}
      }, null, 8, _hoisted_1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.state.consentEnabled,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.consentEnabled) = $event)),
                binary: true,
                class: _normalizeClass({
                  'p-invalid': _ctx.v$.consentEnabled.$invalid && _ctx.state.submitted,
                })
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.state.gdprConsentEnabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.gdprConsentEnabled) = $event)),
                binary: true,
                class: _normalizeClass({
                  'p-invalid':
                    _ctx.v$.gdprConsentEnabled.$invalid && _ctx.state.submitted,
                })
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.t("content.register.footer.termsOfUseText1")) + " ", 1),
                _hoisted_7,
                _createVNode(_component_router_link, {
                  class: "router-link text-color-blue",
                  to: "/terms-and-conditions",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.register.footer.termsOfUseText2")), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t("content.register.footer.termsOfUseText3")) + " ", 1),
                _createVNode(_component_router_link, {
                  class: "router-link text-color-blue",
                  to: "/gdpr-rights-employee",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.register.footer.termsOfUseTextEmployee")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: _ctx.t('header.gdprConsentTitle'),
            class: "minWidth",
            onClick: _ctx.onClickRegister
          }, null, 8, ["label", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}